import { AdiantamentoDisponivel } from '../interfaces/dados-pagamento';

export const ADIANT_REFRESH_S = 5;
export const ADIANT_REFRESH_JANELA_S = 60;
export const ADIANT_DESTAQUE_MS = 4000;
export const ADIANT_BLOQUEIO_MANUAL_S = 30;

/**
 * Lista a exibir, seleção sem os adiantamentos que sumiram e os nrs que não estavam na lista
 * anterior. Resposta vazia com lista já carregada é ignorada: o service devolve [] também em erro.
 */
export function mesclarAdiantamentos(
  anterior: AdiantamentoDisponivel[],
  nova: AdiantamentoDisponivel[],
  selecionados: Set<number>,
): { lista: AdiantamentoDisponivel[]; selecionados: Set<number>; novos: number[] } {
  if (nova.length === 0 && anterior.length > 0) return { lista: anterior, selecionados, novos: [] };
  const naNova = new Set(nova.map(a => a.nrAdiantamento));
  const naAnterior = new Set(anterior.map(a => a.nrAdiantamento));
  return {
    lista: nova,
    selecionados: new Set([...selecionados].filter(nr => naNova.has(nr))),
    novos: nova.filter(a => !naAnterior.has(a.nrAdiantamento)).map(a => a.nrAdiantamento),
  };
}

/**
 * Rebusca os adiantamentos enquanto o modal está aberto: o adiantamento do pagamento
 * às vezes demora a ser criado e não vem na primeira consulta.
 */
export class BuscaAdiantamentos {
  procurando = false;
  /** A janela acabou com o modal aberto: hora de sugerir o Atualizar manual. */
  encerrada = false;
  segundosParaProxima = 0;
  /** Segundos até o Atualizar manual liberar de novo (evita clique repetido). */
  bloqueioManual = 0;
  private timer: ReturnType<typeof setInterval> | null = null;
  private restanteJanela = 0;
  private emCurso = false;

  constructor(
    private readonly buscar: () => Promise<AdiantamentoDisponivel[]>,
    private readonly aplicar: (lista: AdiantamentoDisponivel[]) => void,
  ) {}

  iniciar(): void {
    this.parar();
    this.restanteJanela = ADIANT_REFRESH_JANELA_S;
    this.segundosParaProxima = ADIANT_REFRESH_S;
    this.procurando = true;
    this.timer = setInterval(() => this.segundo(), 1000);
  }

  parar(): void {
    if (this.timer !== null) clearInterval(this.timer);
    this.timer = null;
    this.procurando = false;
    this.encerrada = false;
  }

  async atualizarAgora(): Promise<void> {
    if (this.emCurso) return;
    this.emCurso = true;
    try {
      this.aplicar(await this.buscar());
    } finally {
      this.emCurso = false;
    }
  }

  /** Trava o Atualizar manual; os segundos correm junto com a janela de busca. */
  travarManual(): void {
    this.bloqueioManual = ADIANT_BLOQUEIO_MANUAL_S;
  }

  private segundo(): void {
    if (this.bloqueioManual > 0) this.bloqueioManual--;
    this.restanteJanela--;
    this.segundosParaProxima--;
    if (this.segundosParaProxima <= 0) {
      this.segundosParaProxima = ADIANT_REFRESH_S;
      this.atualizarAgora();
    }
    if (this.restanteJanela <= 0) {
      this.parar();
      this.encerrada = true;
    }
  }
}
